import { ConsentAwareAnalytics } from "@/components/legal/ConsentAwareAnalytics";
import { CartProvider } from "@/hooks/useCart";
import App from "./App";

/** The app tree shared by the browser entry and the build-time prerenderer. */
export function Root() {
  return (
    <CartProvider>
      <App />
      <ConsentAwareAnalytics />
    </CartProvider>
  );
}
